module.exports = __webpack_public_path__ + "static/media/chart-12k-v2--black.62cd6808.svg";